import React from "react";
import { Link, Events, animateScroll as scroller } from "react-scroll";
export default class SiteFooter extends React.PureComponent {
  render() {
    return (
      <div id="footer">
        <footer>
          <div className="footer-top fullwidth">
            <div className="container">
              <div className="row text-center">
                <div className="col-sm-12 col-12">
                  <Link
                    to="top-section"
                    offset={-100}
                    spy={true}
                    smooth={true}
                    duration={500}
                    className="footer-logo"
                  >
                    <img src="/img/Group72.svg" alt="logo" />
                  </Link>
                </div>
                <div className="col-sm-12 col-12">
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/cpfoodservicesydney/"
                      >
                        <img
                          src="/img/social-facebook-circular-button.svg"
                          alt="facebook"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright-section text-center fullwidth">
            <div className="container">
              <span>
                Copyright © 2019 CP Food Service. All Rights Reserved.
              </span>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sitefooter/index.jsx